<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <div class="container">
      <br />
      <div class="terms">
        <a href="/terms" class="text-white fw-500" target="_blank">Términos y Condiciones</a> &nbsp;&nbsp;
        <a href="/policy" class="text-white fw-500" target="_blank">Políticas de Privacidad</a>
      </div>
      <br />
      <nav>
        <ul>
          <li>
            <el-tooltip class="item" content="Follow us on Twitter" placement="top">
              <a href="https://twitter.com/ICONSoluciones" target="_blank" class="d-block mx-2">
                <i class="fab fa-twitter fa-lg"></i>
              </a>
            </el-tooltip>
          </li>
          <li>
            <el-tooltip class="item" content="Like us on Facebook" placement="top">
              <a href="https://www.facebook.com/proyectosees" target="_blank" class="d-block mx-2">
                <i class="fab fa-facebook-square fa-lg"></i>
              </a>
            </el-tooltip>
          </li>
          <li>
            <el-tooltip class="item" content="Check our GitHub" placement="top">
              <a href="https://github.com/iconsees" target="_blank" class="d-block mx-2">
                <i class="fab fa-github-alt fa-lg"></i>
              </a>
            </el-tooltip>
          </li>
        </ul>
      </nav>
      <div
        class="copyright"
      >&copy; {{ year }}, Eficiencia Energética y Seguridad S.A. de C.V. ~ Powered by <a href="http://www.fondepro.gob.sv/" class="text-primary fw-500" title="FONDEPRO" target="_blank"><img class="fondepro-logo" src="img/fondepro.png" alt="FONDEPRO"></a></div>
    </div>
  </footer>
</template>
<script>
import { Tooltip } from "element-ui";
export default {
  components: {
    [Tooltip.name]: Tooltip
  },
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
.footer .terms {
  text-align: center !important;
}
@media screen and (max-width: 768px) {
  .footer nav {
    display: block !important;
    float: none !important;
  }

  .footer ul li a {
    color: inherit;
    padding: 13px;
  }

  .footer ul:not(.links-vertical) {
    line-height: 3.1;
    text-align: center;
  }

  .footer .copyright {
    text-align: center !important;
  }
}
</style>
